import { C_PATH_ROUTES } from "@/src-refactor/modules/shared/model/const/path.const";
import useAlert from "@rf-hooks/useAlert";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

const useHandleCancelFormProperty = () => {
  const { alert } = useAlert();
  const navigate = useNavigate();

  const handleOpenAlert = useCallback(() => {
    alert({
      title: "Aviso",
      color: "warning.main",
      type: "warning",
      message: "Estas seguro que quieres salir del formulario",
      confirmBtnMessage: "Salir",
      declineBtnMessage: "Quedarse"
    }).then((result: any) => {
      if (result.type.confirm) {
        navigate(C_PATH_ROUTES.REALESTATE.LIST);
      }
    });
  }, []);
  return handleOpenAlert;
};
export default useHandleCancelFormProperty;
